import type { PaletteOptions } from "@mui/material/styles";

import { colors } from "./tokens/colors";
import { semanticColors } from "./tokens/semanticColors";

export type ThemeColors = {
  primaryLight: string;
  primaryMain: string;
  primaryDark: string;
  primaryAccent: string;
  webBlau100: string;
  webBlau300: string;
  scoutColor: string;
  scoutSecondaryColor: string;
  schwarzgrau900: string;
  schwarzgrau700: string;
  schwarzgrau500: string;
};

export const palette: PaletteOptions = {
  mode: "light",
  common: {
    black: colors.gray.black,
    white: colors.gray.white,
  },
  primary: {
    light: colors.blue[400],
    main: colors.blue[500],
    dark: colors.blue[700],
    contrastText: colors.gray.white,
  },
  secondary: {
    light: semanticColors.surface.blueBg,
    main: semanticColors.interactive.secondarySurface,
    dark: semanticColors.interactive.secondarySurfaceHover,
    contrastText: semanticColors.interactive.primary,
  },
  success: {
    light: colors.green[100],
    main: semanticColors.feedback.success.main,
    dark: colors.green[700],
    contrastText: semanticColors.text.inverse,
  },
  warning: {
    light: colors.orange[100],
    main: semanticColors.feedback.warning.main,
    dark: colors.orange[600],
    contrastText: semanticColors.text.inverse,
  },
  error: {
    light: colors.red[100],
    main: semanticColors.feedback.error.main,
    dark: colors.red[700],
    contrastText: semanticColors.text.inverse,
  },
  text: {
    primary: semanticColors.text.primary,
    secondary: semanticColors.text.secondary,
    disabled: semanticColors.text.tertiary,
  },
  divider: semanticColors.border.subtle,
  background: {
    default: semanticColors.background.canvas,
    paper: semanticColors.background.paper,
  },
  action: {
    hover: semanticColors.surface.blueBg,
    selected: semanticColors.surface.blueBg,
    disabled: colors.gray[300],
    disabledBackground: semanticColors.surface.disabled,
  },
  invited: {
    main: semanticColors.surface.invited,
    light: semanticColors.surface.invited,
    dark: colors.gray[100],
    contrastText: semanticColors.text.primary,
  },
  uploadFildIndexSelection: {
    main: semanticColors.surface.uploadSelection,
    light: semanticColors.background.subtle,
    dark: colors.gray[200],
    contrastText: semanticColors.text.inverse,
  },
};

// Legacy aliases kept temporarily so existing theme.themeColors consumers keep working
// while the app migrates to semantic MUI palette usage.
export const themeColors: ThemeColors = {
  primaryLight: semanticColors.surface.blueBg,
  primaryMain: semanticColors.interactive.primary,
  primaryDark: semanticColors.interactive.primaryStrong,
  primaryAccent: colors.blue[200],
  webBlau100: semanticColors.surface.blueBg,
  webBlau300: colors.blue[200],
  scoutColor: "#3DF5DC",
  scoutSecondaryColor: "#09D4B8",
  schwarzgrau900: semanticColors.text.primary,
  schwarzgrau700: semanticColors.text.secondary,
  schwarzgrau500: semanticColors.text.tertiary,
};
